import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {
  getStartOfYesterday(): Date {
    const today = new Date();
    const yesterday = new Date(today.setDate(today.getDate() -1));
    yesterday.setUTCHours(0);
    yesterday.setUTCMinutes(0);
    yesterday.setUTCSeconds(0);
    yesterday.setUTCMilliseconds(0);
    return yesterday;
  }

  diffFromNow(dateTime: string): number {
    const utcNow = this.getCurrentDate().getTime();
    const activityUTCDate = new Date(dateTime).getTime();
    const diff = utcNow - activityUTCDate;
    return diff;
  }

  getDateTimeWithoutTimezone(dateTime: string): string {
    return dateTime.substring(0, 19);
  }

  offset(dateTime: string, offsetMilliseconds: number): string {
    const dateMs = this.getDateFromString(dateTime).getTime();
    const offsetDateMs = dateMs + offsetMilliseconds;
    const offsetDate = this.getDateFromMilliseconds(offsetDateMs);
    const isoDateString = offsetDate.toISOString();
    return isoDateString;
  }

  getCurrentDate(): Date {
    return new Date();
  }

  getDateFromString(dateTime: string): Date {
    return new Date(dateTime);
  }

  getDateFromMilliseconds(ms: number): Date {
    return new Date(ms);
  }

  getNow(): number {
    return Date.now();
  }

  getNowAsString(): string {
    return (new Date()).toISOString();
  }
}
